export const withRowType = <TRowType extends string>(rowType: TRowType) =>
  <TItem extends object>(item: TItem): TItem & { rowType: TRowType } => ({ ...item, rowType });
